export default __webpack_public_path__ + "static/media/fan_mode_off.78f89850.png";